import historicsFields from '../fields/historicsFields';

/**
 * @param {Object} data
 * @param {Object} query
 * @returns {Object}
 */
const getHistoricsExportDefaultQuery = (data, query) => {
    const hasActionTimestampFilter = query?.filters?.some(
        (filter) => filter.key === historicsFields.COMMON.ACTION_TIMESTAMP.key
    );
    const { minCreatedAt, maxCreatedAt } = data?.extraInformation || {};

    return !hasActionTimestampFilter && minCreatedAt && maxCreatedAt
        ? { actionTimestamp: `${minCreatedAt}_value_${maxCreatedAt}` }
        : null;
};

export default getHistoricsExportDefaultQuery;